module.exports = __webpack_public_path__ + "static/media/close-ic.83a33d94.svg";